import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import { DemandPartnerType } from '../../../utils/participantFunctions.ts';

export interface ParticipantBuyersSingleInfoProps {
  demandPartnerType: DemandPartnerType;
}

export const ParticipantBuyersSingleInfo = ({ demandPartnerType }: ParticipantBuyersSingleInfoProps) => {
  const { t } = useTranslation();

  const participantBuyersSingleInfo = {
    [DemandPartnerType.DV360]: t('For DV360 DSP you are allowed to select only one DSP Seat ID.'),
  }[demandPartnerType];

  return (
    <Grid size={12}>
      <FormHelperText data-test="buyer-dv360-info">{participantBuyersSingleInfo}</FormHelperText>
    </Grid>
  );
};
